/**
 * PicaService Features Constants
 *
 * Feature keys for reference in code.
 * Each feature has its own Vue component in ./features/
 */

export const FEATURE_KEYS = {
    PHOTOGRAPHER_PICK: 'photographer_pick',
    COLLABORATOR_LIMITS: 'collaborator_limits',
    PRICE_LOCK_AFTER_SALE: 'price_lock_after_sale',
    PHOTO_EDITOR: 'photo_editor',
}

/**
 * Permission to see the features page
 */
export const FEATURES_SEE_PERMISSION = 'event_wizard.features.see'

/**
 * Get the permission key for a specific feature
 * @param {string} featureKey - The feature key (e.g., 'photographer_pick')
 * @returns {string} The permission key (e.g., 'event_wizard.features.photographer_pick')
 */
export function getFeaturePermission(featureKey) {
    return `event_wizard.features.${featureKey}`
}

export default {
    FEATURE_KEYS,
    FEATURES_SEE_PERMISSION,
    getFeaturePermission
}
